import { withStyles } from '@material-ui/core/styles'
import React, { Component } from 'react'
import GridList from '@material-ui/core/GridList'
import GridListTile from '@material-ui/core/GridListTile'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Button from '@material-ui/core/Button'
import UploadFileIcon from '@material-ui/icons/FileUpload'


const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    gridList: {
        flexWrap: 'nowrap',
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)'
    },
    expansionPanelDetails: {
        overflow: 'hidden'
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit
    },
    menu: {
        width: 200
    },
    button: {
        margin: 50
    }
})

const expansionNodes = {
    'Change': 'change',
    'Current State': 'currentState',
    'Event': 'event'
}

class OrderHistoryTab extends Component {
    state = {
        orderHistoryDump: '',
        file: ''
    }

    handleFileUpload = e => {
        if (!e.target.files) {
            return
        }
        const file = e.target.files[0]
        this.setState({ file })

        const reader = new FileReader()
        reader.onload = (evt) => {
            const { result } = evt.target
            this.setState({ orderHistoryDump: JSON.parse(result) })
        }
        reader.readAsText(file, 'utf-8')
    }


    render() {
        const { classes } = this.props
        const { file, orderHistoryDump } = this.state
        console.log(orderHistoryDump)
        console.log(this.state)

        return (
            <div>
                <Button
                    component="label"
                    variant="outlined"
                    startIcon={<UploadFileIcon />}
                    sx={{ marginRight: '1rem' }}
                >
                    <UploadFileIcon />
                    {file ? 'Reupload (' + file.name + ')' : 'Upload JSON'}
                    <input type="file" accept=".json" hidden onChange={this.handleFileUpload} />
                </Button>


                <div className={classes.root}>
                    {orderHistoryDump ?
                        <GridList className={classes.gridList} spacing={10} cols={3} cellHeight={'auto'}>
                            {orderHistoryDump.map(step => (
                                <GridListTile>
                                    <Card className={classes.card}>
                                        <CardContent>
                                            <Typography variant="headline" component="h1">
                                                {step.eventType}
                                            </Typography>
                                            <Typography className={classes.pos} color="textSecondary">
                                                {new Date(step.change.modifiedAt).toLocaleString('uk-UA')}
                                            </Typography>

                                            {Object.keys(expansionNodes).map(node => (
                                                <ExpansionPanel>
                                                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                                        <Typography className={classes.heading}>{node}</Typography>
                                                    </ExpansionPanelSummary>
                                                    <ExpansionPanelDetails style={{
                                                        maxWidth: '100%',
                                                        width: '100%',
                                                        overflowX: 'auto'
                                                    }}>
                                                        <Typography>

                                                    <pre>
                                                        {JSON.stringify(step[expansionNodes[node]], null, 2)}
                                                    </pre>

                                                        </Typography>
                                                    </ExpansionPanelDetails>
                                                </ExpansionPanel>
                                            ))}

                                        </CardContent>
                                    </Card>
                                </GridListTile>
                            ))}
                        </GridList> : <div></div>}
                </div>
            </div>
        )
    }
}

export default withStyles(styles)(OrderHistoryTab)



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OrderHistoryTab/OrderHistoryTab.js